import fastJson from 'fast-json-stringify';
import sjson from 'secure-json-parse';

export const stringify = fastJson({});
export const parse = sjson.parse;
